module.exports = __webpack_public_path__ + "static/mongo-bread-13852b2d82189e450de046a9ec53e0b2.jpg";